import React, { useContext } from 'react';

export const UpSwitchToExpertContext = React.createContext({
  showSwitchToExpert: false,
});
export const useUpSwitchToExpertContext = () => useContext(UpSwitchToExpertContext);
